import env from '@beam-australia/react-env';

export const REACT_APP_API_HOST = env('API_HOST');
export const REACT_APP_HOST_URL = env('HOST_URL');
export const REACT_APP_STRIPE_SECRET = env('STRIPE_SECRET');
export const REACT_APP_ENVIRONMENT = env('ENVIRONMENT');
export const REACT_APP_SESSION_DETAILS_CDN = env('SESSION_DETAILS_CDN');
